import { useTranslation } from 'react-i18next'

import { IPlanMenuControlOrdersRequest } from 'core/api/dto/PlanMenuControlDto'
import { useSearchParams } from 'react-router-dom'

import AppBtn, { AppBtnColor, AppBtnSize } from 'components/btn/AppBtn'
import { useGetPlanMenuCloseDimensionQuery } from 'core/api/PlanMenuCloseDimensionApi'

export interface IMilletBlockProps {
  pageParams: IPlanMenuControlOrdersRequest | null
  onClick: () => void
}

export const MilletBlock = ({ pageParams, onClick }: IMilletBlockProps) => {
  const { t } = useTranslation()

  const [searchParams] = useSearchParams()
  const currentDimension = searchParams.get('dimension')
  const { data } = useGetPlanMenuCloseDimensionQuery({
    id: Number(currentDimension),
  })

  return (
    <>
      {data ? (
        <div className={`millet-block `} onClick={onClick}>
          <AppBtn sized={AppBtnSize.fullWidth} color={AppBtnColor.lightViolet}>
            <div>
              <i className="an-ico an-ico-bowl" />
              <span>{t('Выбрать тару')}</span>
            </div>
          </AppBtn>
          <div className="text-info">
            <i className="an-ico an-ico-info-circle " />
            <span>
              {t(
                'Выберите необходимую тару из списка, применив её к замеру блюда',
              )}
            </span>
          </div>
          <div>
            <div className="">
              <img
                src={
                  data.millet?.imageOnS3 ||
                  data.millet?.image ||
                  '../../assets/images/fake-millet.png'
                }
                alt=""
              />
            </div>

            <div className={'label-text'}>{t('Название тары')}</div>
            <div className={'title'}>{data?.millet?.name}</div>
            <div className={'text'}>{`${data?.weightOfMillet} кг`} </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  )
}